import { alpha, Box, LinearProgress, Typography } from "@mui/material";

import { bytesToMB, getProgressPercent } from "../utils/helper";
import { useTheme } from "@emotion/react";

export const Storage = ({ user }) => {
  const theme = useTheme();

  // Handle cases where user data might be missing
  if (!user || !user.storage) {
    return (
      <Box>
        <Typography variant="caption" color="text.secondary">
          0 MB used
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {bytesToMB(user?.storage?.usedSpace)} Used of{" "}
        {/* {user?.storagePermission?.noOfAllowed || "0"}{" "} */}
        {"5"} {user?.storagePermission?.format || "GB"}
      </Typography>

      <LinearProgress
        variant="determinate"
        value={getProgressPercent(
          user?.storage?.usedSpace,
          5000,
          user?.storagePermission?.format
        )}
        sx={{
          height: 4,
          borderRadius: 5,
          backgroundColor: alpha(theme.palette.background.default, 0.8),
          "& .MuiLinearProgress-bar": {
            backgroundColor: theme.palette.primary.main,
          },
        }}
      />
    </Box>
  );
};
